module.exports = __webpack_public_path__ + "static/img/ok@2x.563b1487.png";